export { UserBadges as default, UserBadges } from './UserBadges';